import React, { useState } from "react"
import addToMailchimp from "gatsby-plugin-mailchimp"
import NewsletterBackground from "../NewsletterBackground"

const Newsletter = () => {
  const [email, setEmail] = useState("")
  const [result, setResult] = useState({})

  const handleChange = (event) => {
    setEmail(event.target.value)
  }

  const handleSubmit = async (e) => {
    e.preventDefault()
    const result = await addToMailchimp(email)
    setResult(result)
  }

  return (
    <NewsletterBackground>
      <section className="signup-section" id="newsletter">
        <div className="container">
          <div className="row">
            <div className="col-md-10 col-lg-8 mx-auto text-center">
              <i className="far fa-paper-plane fa-2x mb-2 text-white" />
              <h2 className="text-white mb-5">Subscribe to receive our newsletter!</h2>
              <form className="form-inline d-flex" onSubmit={handleSubmit}>
                <input className="form-control flex-fill mr-0 mr-sm-2 mb-3 mb-sm-0" id="inputEmail" type="email"
                       placeholder="Enter email address..." onChange={handleChange} />
                <button className="btn btn-primary mx-auto" type="submit">Subscribe</button>
              </form>
              <div className=' mt-4 text-white text-center font-weight-bold text-2xl'
                   dangerouslySetInnerHTML={{ __html: result.msg }} />
            </div>
          </div>
        </div>
      </section>
    </NewsletterBackground>

  )
}

export default Newsletter
